import aiPreferencesImage from '../assets/screenshots/showcase-ai-preferences.jpg';
import dailyPlanImage from '../assets/screenshots/showcase-daily-plan.jpg';
import navigationImage from '../assets/screenshots/showcase-navigation.jpg';
import routeMapImage from '../assets/screenshots/showcase-route-map.jpg';

export const navigation = [
  { label: 'Özellikler', to: '/#features' },
  { label: 'Nasıl çalışır?', to: '/#how-it-works' },
  { label: 'Gizlilik', to: '/privacy' },
  { label: 'Destek', to: '/contact' },
];

export const features = [
  {
    icon: '✦',
    title: 'AI gezi planlama',
    description:
      'Süre, ilgi alanı ve ulaşım tercihine göre günlere ayrılmış kişisel bir gezi planı oluştur.',
  },
  {
    icon: '⌖',
    title: 'Yakındaki yerleri keşfet',
    description:
      'Çevrendeki kültür, doğa, tarih ve lezzet duraklarını tek bakışta keşfet.',
  },
  {
    icon: '↝',
    title: 'Rota ve navigasyon',
    description:
      'Durakları mantıklı bir sırada gör, yolculuğunu harita üzerinden kolayca takip et.',
  },
  {
    icon: '♡',
    title: 'Kaydet ve çevrimdışı kullan',
    description:
      'Sevdiğin yerleri ve rotaları kaydet; premium erişimle planlarını çevrimdışı yanında taşı.',
  },
];

export const steps = [
  {
    number: '01',
    title: 'Tercihlerini seç',
    description: 'Şehri, gezi süresini, ilgi alanlarını ve ulaşım biçimini belirle.',
  },
  {
    number: '02',
    title: 'Planını oluştur',
    description: 'Tripzy, uygun durakları günlere ve yakınlığa göre düzenlesin.',
  },
  {
    number: '03',
    title: 'Keşfetmeye başla',
    description: 'Rotanı takip et, ilerlemeni kaydet ve planını yolculuk sırasında yönet.',
  },
];

export const screenshotSlots = [
  {
    title: 'Harita ve rota',
    description: 'Gezi günlerini ve duraklarını harita üzerinde birlikte incele.',
    accent: 'map',
    image: routeMapImage,
    alt: 'Tripzy uygulamasında Paris gezi duraklarının ve renkli rotaların harita görünümü',
    width: 1080,
    height: 2031,
  },
  {
    title: 'AI planlama',
    description: 'Süre, tempo ve ulaşım tercihlerine göre kişisel planını oluştur.',
    accent: 'ai',
    image: aiPreferencesImage,
    alt: 'Tripzy AI gezi planlama ekranında şehir, gün, tempo ve ulaşım tercihleri',
    width: 972,
    height: 2897,
  },
  {
    title: 'Günlük gezi planı',
    description: 'Her günün duraklarını, sırasını ve mekân ayrıntılarını tek yerde gör.',
    accent: 'plan',
    image: dailyPlanImage,
    alt: 'Tripzy uygulamasında Paris gezisinin birinci gününe ait sıralı mekân planı',
    width: 972,
    height: 3530,
  },
  {
    title: 'Navigasyon',
    description: 'Kalan mesafeyi ve yönlendirmeleri yolculuk boyunca takip et.',
    accent: 'route',
    image: navigationImage,
    alt: 'Tripzy aktif navigasyon ekranında rota, yönlendirme, kalan mesafe ve süre bilgileri',
    width: 1080,
    height: 2031,
  },
];
